import { Table, TD, TR } from '@ag-media/react-pdf-table';
import { BRAINFUNCTION_LEGEND_OPTIONS } from 'features/patient/patient-summary/components/displays/components/legend';
import { TableText } from './pdf-default-components';

const items = BRAINFUNCTION_LEGEND_OPTIONS.map(_ => {
  switch (_.text) {
    case 'Extremely affected':
      return { ..._, text: 'Extremely' };
    case 'Significantly affected':
      return { ..._, text: 'Significantly' };
    default:
      return _;
  }
});

export function ColorLegend() {
  return (
    <Table
      weightings={[0.1, 0.9]}
      style={{
        borderTopLeftRadius: 6,
        borderBottomLeftRadius: 6,
        overflow: 'hidden'
      }}
      tdStyle={{
        border: '0px solid black',
        padding: 1
      }}
    >
      {items.map((item, i) => (
        <TR key={i}>
          <TD style={{ backgroundColor: item.color }}></TD>
          <TD
            style={{
              padding: 2,
              paddingLeft: 4
            }}
          >
            <TableText>{item.text}</TableText>
          </TD>
        </TR>
      ))}
    </Table>
  );
}
